import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public user$ = this.userService.getCurrentUser();

  constructor(
    private userService: UserService,
  ) { }

  ngOnInit(): void {
  }

}
